import Navbar from './NavBar/NavBarSGI'
//import './Manutencao.css';

function Sgi(props) {



    
  return <div className=''>
    <Navbar />
  </div>

}

export default Sgi;